import BrandHeader from './brand-header';

export default {
  init: function (selector) {
    const brandHeader = document.querySelector(selector);

    if (brandHeader) {
      const brandHeaderInit = new BrandHeader(brandHeader);
      brandHeaderInit.init();
    }
  }
};
